export const track = (opts) => {
  const { ICTemplate = '' } = opts;
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && !!ICTemplate) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('instant-checkout.load', { ICTemplate });
  }
};
